import React from 'react';
import { CheckIcon } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
export function WhatYouGet() {
  const items = [{
    title: 'La Guía Maestra del Protocolo 72h',
    desc: 'El paso a paso de qué comer y qué evitar desde el viernes por la noche hasta el lunes por la mañana.'
  }, {
    title: "La Lista de Compras 'Anti-Gas'",
    desc: 'Para que no pierdas ni un segundo adivinando qué comprar en el supermercado.'
  }, {
    title: "El Mapa del 'Interruptor de Cortisol'",
    desc: 'Aprende a identificar qué hábitos diarios están inflamando tu vientre sin que te des cuenta.'
  }, {
    title: 'Checklist de Rescate Diario',
    desc: 'Un plan de acción minuto a minuto para asegurar resultados máximos.'
  }, {
    title: 'BONO: El Hábito de los 5 Minutos',
    desc: 'La técnica de drenaje linfático manual que puedes hacer en la ducha para mantenerte desinflamada.'
  }];
  return <section className="bg-white py-20 px-4" data-id="element-241">
      <div className="max-w-6xl mx-auto" data-id="element-242">
        <FadeIn data-id="element-243">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-16" data-id="element-244">
            ¿Qué incluye el{' '}
            <span className="italic text-terracotta" data-id="element-245">Protocolo</span>?
          </h2>

          <div className="max-w-2xl mx-auto" data-id="element-246">
            <ul className="space-y-6" data-id="element-247">
              {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-248">
                  <li className="flex items-start space-x-4 p-4 rounded-2xl hover:bg-cream transition-colors" data-id="element-249">
                    <div className="bg-green-50 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-250">
                      <CheckIcon className="w-6 h-6 text-sage" data-id="element-251" />
                    </div>
                    <div data-id="element-252">
                      <h3 className="font-bold text-brown-dark text-lg mb-1" data-id="element-253">
                        {item.title}
                      </h3>
                      <p className="text-brown-body" data-id="element-254">{item.desc}</p>
                    </div>
                  </li>
                </FadeIn>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}